import { render, staticRenderFns } from "./UserDepartmentEdit.vue?vue&type=template&id=7c037d2a"
import script from "./UserDepartmentEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDepartmentEdit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports